/** @format */

import React, { Component } from "react";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Footer from "../components/Footer";

export default class ObligacionesPagadas extends Component {
  callColapsar = (art) => {
    let article = document.getElementById(art);
    article.classList.toggle("expanded");
  };
  render() {
    return (
      <div style={{ overflow: "hidden" }}>
        <div className="text-center">
          {this.props.objFinacesPaid.map((_, i) => {
            return (
              <div>
                <div
                  key={i}
                  className="card-header background-sub-cursos d-flex"
                  style={{ alignItems: "center" }}
                >
                  <div className="mr-auto p-2 PagarTitleL">
                    Periodo : {_.period}
                  </div>
                  <div className="ml-auto p-2 PagarTitleR">
                    <ExpandMoreIcon
                      style={{ color: "black" }}
                      onClick={() => this.callColapsar(`${i}_article`)}
                    ></ExpandMoreIcon>
                  </div>
                </div>
                {/*  */}
                <article id={`${i}_article`} className="article mt-2">
                  <div
                    className="row align-content-end"
                    key={i + "FinancesPaid"}
                  >
                    <div className="col"></div>
                    <div className="col-10">
                      <table className="table">
                        <thead className="thead-light Historial-header">
                          <tr>
                            <th scope="col">Fecha Vencimiento</th>
                            <th scope="col">Concepto</th>
                            <th scope="col">Número de Documento</th>
                            <th scope="col">Cuota</th>
                            <th scope="col">Importe</th>
                            <th scope="col">Pagado</th>
                          </tr>
                        </thead>
                        <tbody>
                          {_.payments.map((payment, g) => {
                            return (
                              <tr key={g}>
                                <td>{payment.paidDate}</td>
                                <td>{payment.concept}</td>
                                <td>{payment.documentNumber}</td>
                                <td>{payment.balance}</td>
                                <td>{payment.import}</td>
                                <td>{payment.paid}</td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                    <div className="col"></div>
                  </div>
                </article>
                {/*  */}
              </div>
            );
          })}
        </div>
      </div>
    );
  }
}
